!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.storeblocks=t():e.storeblocks=t()}(self,(()=>(()=>{"use strict";var e={568:(e,t,n)=>{n.d(t,{Additions:()=>d,AutosuggestBase:()=>a,Container:()=>s,Label:()=>l,NativeInput:()=>i,Suffix:()=>c});var r=n(770),o=n.n(r);const a=o().div.attrs({className:"autosuggest"})`
  display: inline-flex;
  flex-direction: column;

  color: var(--color-on-background);
  font-family: 'Open Sans';
  font-size: 16px;
  line-height: 24px;

  &[aria-disabled='true'] {
    color: var(--color-disabled);
  }

  ${({fluid:e})=>e&&r.css`
      width: 100%;
      max-width: 100%;

      & > ${s} {
        width: 100%;

        & > select {
          width: 100%;
        }
      }
    `}

  & > .hint {
    margin: -8px 0 16px 0;
  }
`,l=o().label`
  font-weight: 600;
  word-wrap: break-word;

  margin-bottom: 16px;
`,i=o().input`
  width: 100%;
  height: 40px;
  padding: 0 8px;
  border: none;
  box-sizing: border-box;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  caret-color: var(--color-on-background);
  /* hide arrows on input type number start*/
  /* Chrome, Safari */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  /* Firefox */
  &[type='number'] {
    appearance: textfield;
    -moz-appearance: textfield;
  }

  /* clears the ‘X’ from Internet Explorer */
  &[type='search']::-ms-clear {
    display: none;
    width: 0;
    height: 0;
  }
  &[type='search']::-ms-reveal {
    display: none;
    width: 0;
    height: 0;
  }
  /* clears the ‘X’ from Chrome */
  &[type='search']::-webkit-search-decoration,
  &[type='search']::-webkit-search-cancel-button,
  &[type='search']::-webkit-search-results-button,
  &[type='search']::-webkit-search-results-decoration {
    display: none;
  }

  &:focus-visible {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    background: var(--color-on-primary);
    caret-color: var(--color-disabled);
    color: var(--color-disabled);
  }
`,s=o().div`
  position: relative;
  display: flex;
  align-items: center;
  align-self: flex-start;
  border-radius: 2px;
  border: 1px solid var(--color-on-background);
  background-color: var(--color-background);

  cursor: text;

  &:focus-within {
    border: 1px solid var(--color-selection);
    outline: 1px solid var(--color-selection);
  }

  ${({disabled:e})=>e&&r.css`
      color: var(--color-disabled);
      border: 1px solid var(--color-disabled);
      cursor: not-allowed;
    `}

  ${({$small:e,$large:t,fluid:n})=>e?r.css`
        width: 96px;
      `:t?r.css`
        width: 288px;
      `:n?r.css`
        width: 100%;
      `:r.css`
      width: 148px;
    `}

  ${({readOnly:e})=>e&&r.css`
      &:focus-within {
        outline: none;
      }
    `}

  ${({$success:e,$warning:t,$error:n})=>e?r.css`
        outline: 2px solid var(--color-success-accent);
        border: 1px solid var(--color-success-accent);
      `:t?r.css`
        outline: 2px solid var(--color-warning-accent);
        border: 1px solid var(--color-warning-accent);
      `:n?r.css`
        outline: 2px solid var(--color-error-accent);
        border: 1px solid var(--color-error-accent);
      `:""}
`,c=o().div`
  pointer-events: none;
  margin-right: 8px;
  white-space: nowrap;
`,d=o().div`
  display: flex;
  align-items: center;

  z-index: 1;

  > .icon-button {
    margin: 0 16px 0 8px;
  }
`},770:e=>{e.exports=require("styled-components")}},t={};function n(r){var o=t[r];if(void 0!==o)return o.exports;var a=t[r]={exports:{}};return e[r](a,a.exports,n),a.exports}n.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return n.d(t,{a:t}),t},n.d=(e,t)=>{for(var r in t)n.o(t,r)&&!n.o(e,r)&&Object.defineProperty(e,r,{enumerable:!0,get:t[r]})},n.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),n.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var r={};return(()=>{n.r(r),n.d(r,{Autosuggest:()=>C,default:()=>j});const e=require("react");var t=n.n(e);const o=require("@storeblocks/hint");var a=n.n(o);const l=require("@storeblocks/icon"),i=require("@storeblocks/inline-alert");var s=n.n(i),c=n(568),d=n(770),u=n.n(d);const p=u().div`
  display: block;
  cursor: pointer;
  padding: 1px;

  &:hover {
    background-color: var(--color-overlay-hover-darken);
  }
`,b=u().div`
  padding: 5px;
  border: 2px solid transparent;
  ${({active:e})=>e&&d.css`
      border: 2px solid #00f;
    `};
`,v=u().p`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  color: #191919;
`,f=u()(v)`
  font-weight: 600;
`,m=u()(v)`
  padding: 8px;
  font-size: 14px;
  line-height: 24px;
`;var g=function(e,t){var n={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(r=Object.getOwnPropertySymbols(e);o<r.length;o++)t.indexOf(r[o])<0&&Object.prototype.propertyIsEnumerable.call(e,r[o])&&(n[r[o]]=e[r[o]])}return n};function x(e){var{value:n,hint:r,sub:o,active:a,label:l}=e,i=g(e,["value","hint","sub","active","label"]);return t().createElement(p,Object.assign({role:"option"},i),t().createElement(b,{active:a},t().createElement(f,null,null!=l?l:n),r&&t().createElement(v,null,r),o&&t().createElement(v,null,o)))}const h=e=>"string"==typeof e?{value:e,hint:void 0,sub:void 0}:e;function w({disabled:t,onEvent:n,parentEventHandler:r}){return(0,e.useCallback)((e=>{t||n(),r&&r(e)}),[t,n,r])}const y=e=>"string"==typeof e&&e.length>0,k=require("@storeblocks/loading-indicator");var I=n.n(k);const E=u().div`
  background-color: white;
  border: 2px solid var(--color-selection);
  border-radius: 0 0 2px 2px;
  border-top: none;
  box-sizing: border-box;
  left: 1px;
  margin-left: -2px;
  max-height: ${({maxHeight:e="288px"})=>e};
  overflow: auto;
  position: absolute;
  padding: 1px;
  padding-top: 0;
  top: 40px;
  width: calc(100% + 2px);
  z-index: ${({zIndex:e=100})=>e};

  border-top: solid 1px rgba(25, 25, 25, 0.16);
  & > {
    :not(:first-child) {
      border-top: solid 1px rgba(25, 25, 25, 0.16);
    }
  }
`,O=u().div`
  display: flex;
  justify-content: center;
`,$=u()(O)`
  padding: 8px;
`;function S({show:n,isLoading:r,items:o,activeItemIndex:a,handleItemSelected:l,noItemFoundText:i,parentId:s,maxHeight:c,zIndex:d,loadingIndicatorRef:u}){const p=(0,e.useCallback)((e=>t=>{t.preventDefault(),l(e)}),[l]);return n&&t().createElement(E,{maxHeight:c,zIndex:d,role:"listbox",id:`${s}-items`},r&&t().createElement($,{ref:u},t().createElement(I(),{size:"small"})),0===o.length&&!r&&t().createElement(m,null,i),o.length>0&&!r&&o.map(((e,n)=>{var r;return t().createElement(x,Object.assign({},e,{id:`${s}-option-${e.value}`,active:n===a,value:null!==(r=e.label)&&void 0!==r?r:e.value,key:e.value,tabIndex:-1,onMouseDown:p(e)}))})))}const C=(0,e.forwardRef)(((n,r)=>{var o,i,{id:d,name:u,label:p,hint:b,small:v,medium:f,large:m=!0,fluid:g,disabled:x,readOnly:k,trackid:I,success:E,error:O,warning:$,onChange:C,value:j,type:D="search",icon:P="search",suffix:z,labelProps:H,hintProps:F,inputProps:A,suffixProps:T,attentionProps:L,onFocus:M,onBlur:q,onClick:B,onKeyDown:K,isLoading:R=!1,dropdownEnabled:N="auto",noItemFoundText:_="Sorry, no results was found.",limit:V,data:X=[],filter:Z,onItemSelect:U,dropDownMaxHeight:G="288px",dropDownZIndex:J=100}=n,Q=function(e,t){var n={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(n[r]=e[r]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var o=0;for(r=Object.getOwnPropertySymbols(e);o<r.length;o++)t.indexOf(r[o])<0&&Object.prototype.propertyIsEnumerable.call(e,r[o])&&(n[r[o]]=e[r[o]])}return n}(n,["id","name","label","hint","small","medium","large","fluid","disabled","readOnly","trackid","success","error","warning","onChange","value","type","icon","suffix","labelProps","hintProps","inputProps","suffixProps","attentionProps","onFocus","onBlur","onClick","onKeyDown","isLoading","dropdownEnabled","noItemFoundText","limit","data","filter","onItemSelect","dropDownMaxHeight","dropDownZIndex"]);const W=`${d}-input-label`,Y=`${d}-input-suffix`,ee=`${d}-input-attention`,te=(null==F?void 0:F.id)||`${d}-input-hint`,ne=(({error:e,warning:t,success:n})=>y(e)?"error":y(t)?"warning":y(n)?"success":null)({error:O,warning:$,success:E}),re=((e,t)=>t?e[t]:null)({error:O,warning:$,success:E},ne),oe=null!==ne,ae=(0,e.useRef)(null);(0,e.useImperativeHandle)(r,(()=>ae.current));const{filteredData:le,updateFilteredData:ie}=function(t,n,r,o){const a=(0,e.useCallback)((()=>{const e=t.map(h);let a=r?e.filter((({value:e,label:t})=>{var o;return r(null!=t?t:e,null!==(o=null==n?void 0:n.value)&&void 0!==o?o:"")})):e;return o&&(a=a.slice(0,o)),a}),[r,t,o,n]),[l,i]=(0,e.useState)([]),s=(0,e.useCallback)((()=>i(a())),[a,i]);return(0,e.useEffect)((()=>{s()}),[s]),{filteredData:l,updateFilteredData:s}}(X,ae.current,Z,V),[se,ce]=(0,e.useState)(-1),[de,ue]=(0,e.useState)(!1),pe=(0,e.useCallback)((()=>ue(!0)),[ue]),be=(0,e.useCallback)((()=>ue(!1)),[ue]),ve=!!(null===(o=ae.current)||void 0===o?void 0:o.value),fe=(null!==(i="auto"===N?ve:N)&&void 0!==i?i:ve)&&!x&&de,me=(({shouldScroll:t})=>{const n=(0,e.useRef)(null);return(0,e.useEffect)((()=>{var e;t&&(null===(e=n.current)||void 0===e||e.scrollIntoView({behavior:"smooth",block:"nearest"}))})),n})({shouldScroll:fe&&R}),ge=(0,e.useCallback)((e=>{var t,n;const r=null===(n=null===(t=e.nativeEvent)||void 0===t?void 0:t.relatedTarget)||void 0===n?void 0:n.id;(null==r?void 0:r.substring(0,d.length))!==d&&be(),null==q||q(e)}),[d,be,q]),xe=w({disabled:x,onEvent:pe,parentEventHandler:M}),he=w({disabled:x,onEvent:pe,parentEventHandler:B}),we=w({disabled:x,onEvent:(0,e.useCallback)((()=>{pe(),ie(),ce(-1)}),[pe,ie,ce]),parentEventHandler:C}),ye=(0,e.useCallback)((e=>{var t;const n="string"==typeof e?e:null!==(t=e.label)&&void 0!==t?t:e.value;if(function(e,t){Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype,"value").set.call(e,t);const n=new InputEvent("input",{bubbles:!0,cancelable:!0});e.dispatchEvent(n)}(ae.current,n),U){const t=U(n,"string"!=typeof e?e:void 0);ue(t||!1)}else ue(!1)}),[ue,U]),ke=(({id:t,items:n,activeItemIndex:r,setActiveItemIndex:o,dropdownOpen:a,setDropdownOpen:l,handleItemSelected:i,onKeyDown:s})=>{const c=(0,e.useCallback)((e=>{var r;const{value:o}=n[e];null===(r=document.getElementById(`${t}-option-${o}`))||void 0===r||r.scrollIntoView({behavior:"smooth",block:"nearest"})}),[n,t]),d=(0,e.useCallback)((()=>{if(n.length){const e=r<n.length-1?r+1:0;o(e),c(e)}}),[n,r,o,c]),u=(0,e.useCallback)((()=>{if(n.length){const e=r>0?r-1:n.length-1;o(e),c(e)}}),[n,r,o,c]),p=(0,e.useCallback)((()=>{n.length&&(o(0),c(0))}),[n,o,c]),b=(0,e.useCallback)((()=>{n.length&&(o(n.length-1),c(n.length-1))}),[n,o,c]);return(0,e.useCallback)((e=>{switch(e.key){case"ArrowUp":e.preventDefault(),u();break;case"ArrowDown":e.preventDefault(),d();break;case"Enter":n[r]&&a&&(e.preventDefault(),i(n[r]));break;case"Escape":a&&(e.preventDefault(),l(!1));break;case"Home":e.preventDefault(),p();break;case"End":e.preventDefault(),b()}s&&s(e)}),[n,r,a,l,u,d,p,b,i,s])})({id:d,items:le,activeItemIndex:se,setActiveItemIndex:ce,dropdownOpen:de,setDropdownOpen:ue,handleItemSelected:ye,onKeyDown:K});return t().createElement(c.AutosuggestBase,Object.assign({"aria-disabled":x,fluid:g},Q),p&&t().createElement(c.Label,Object.assign({id:W,htmlFor:d},H),p),b&&t().createElement(a(),Object.assign({id:te},F),b),t().createElement(c.Container,{readOnly:k,$small:v,$medium:f,$large:m,fluid:g,disabled:x,$success:E,$warning:$,$error:O},t().createElement(c.NativeInput,Object.assign({id:d,name:u,type:D,$icon:P,suffix:z,"data-trackid":I,"aria-invalid":!!O,"aria-labelledby":`${W}`,"aria-describedby":`${te} ${Y} ${ee}`,onChange:we,onFocus:xe,onBlur:ge,onClick:he,onKeyDown:ke,value:j,readOnly:k,disabled:x,ref:ae,role:"combobox","aria-haspopup":"true","aria-owns":fe?`${d}-items`:null,"aria-expanded":fe,autoComplete:"off","aria-controls":fe?`${d}-items`:null,"aria-activedescendant":se>=0?`${d}-option-${le[se].value}`:null},A)),t().createElement(c.Additions,null,z&&t().createElement(c.Suffix,Object.assign({id:Y},T),z),P&&"none"!==P&&t().createElement("div",{style:{margin:"2px 16px 0 8px"}},t().createElement(l.SystemIcon,{className:"icon",name:P,size:16}))),t().createElement(S,{show:fe,parentId:d,items:le,activeItemIndex:se,handleItemSelected:ye,isLoading:R,loadingIndicatorRef:me,noItemFoundText:_,maxHeight:G,zIndex:J})),oe&&t().createElement(s(),Object.assign({variant:ne,title:re,id:d},L)))})),j=C})(),r})()));
//# sourceMappingURL=index.js.map